<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<button-search ref="buttonSearch" placeholder="要搜索的商品名称" @search="searchEvent"
			style="padding-top: 10px;padding-bottom: 10px;">

			<!-- 高级搜索表单 -->
			<template #form>
				<el-form inline ref="form" :model="form" label-width="80px">
					<el-form-item label="操作人" class="mb-0">
						<el-input v-model="form.title" placeholder="商品名称" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="月份查询" class="mb-0">
						<el-date-picker v-model="form.sj" type="monthrange" align="right" unlink-panels
							range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
							:picker-options="pickerOptions" format="yyyy-MM" value-format="yyyy-MM" size="mini">
						</el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form>
			</template>
		</button-search>
		<div>
			<el-table :max-height="maxHeight" :data="czjllist" style="width: 100%" size="mini" row-key="id"
				:tree-props="{ children: 'child', hasChildren: 'hasChildren' }">
				<el-table-column width="80" align="center">
					<template slot="header" slot-scope="scope">编号</template>
					<template slot-scope="scope">{{scope.row.id}}</template>
				</el-table-column>
				<el-table-column width="160">
					<template slot="header" slot-scope="scope">操作人</template>
					<template slot-scope="scope"><el-button type="success" size="mini"
							plain>{{scope.row.cjr.name}}</el-button></template>
				</el-table-column>
				<el-table-column width="560">
					<template slot="header" slot-scope="scope">操作详情</template>
					<template slot-scope="scope">{{scope.row.czxq}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">创建时间</template>
					<template slot-scope="scope">{{scope.row.create_time}}</template>
				</el-table-column>

				<el-table-column>
					<template slot="header" slot-scope="scope">操作ip</template>
					<template slot-scope="scope">{{scope.row.czip}}</template>
				</el-table-column>
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white"
			style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
		</el-footer>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js'; // 引入 全局共公样式
	import buttonSearch from '@/components/common/button-search.vue';
	import {
		mapState
	} from 'vuex'; // 引入 全局 公共数据
	export default {
		mixins: [common], // 引入mixins里的common.js
		inject: ['layout'], // 依赖注入
		data() {
			return {
				form: {
					sj: "",
					czr: "" //操作人
				},
				maxHeight: 0,
				preUrl: "czrj", //api
				czjllist: [],
				pickerOptions: {
					shortcuts: [{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [new Date(), new Date()]);
						}
					}, {
						text: '今年至今',
						onClick(picker) {
							const end = new Date();
							const start = new Date(new Date().getFullYear(), 0);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近六个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 6);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
			};
		},
		components: {
			buttonSearch
		},
		computed: {
			...mapState({
				user: state => state.user.user
			})
		},
		mounted() {
			this.$nextTick(() => {
				this.maxHeight = window.innerHeight - 240;
			});
		},
		methods: {
			getListUrl() {
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`
			},
			// 处理列表结果
			getListResult(e) {
				this.czjllist = e.list
			},
			// 搜索事件
			searchEvent(e = false) {
				console.log(this.form)
				// // 简单搜索
				// if (typeof e === 'string') {
				// 	this.form.title = e
				// }
				// // 高级搜索
				// this.getList()
			},
			// 清空筛选条件
			clearSearch() {
				this.form = {
					sj: "",
					czr: ""
				}
			},

		}
	};
</script>

<style></style>